import Input from '../../../shared/components/form/input'
import { useState } from "react"
/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import AuthBackgroundImage from '../../../shared/components/AuthImage/AuthBackgroundImage'
import FormLayout from '../../../shared/components/FormLayout/FormLayout'
import FormSection from '../../../shared/components/FormLayout/FormSection'
import Button from '../../../shared/components/Button/Button'
import './FormClientImg.css'

function FormClientImg({ handleSubmit, title, data, clientId, btCancelAction }) {
    const [preview, setPreview] = useState()
    const [clientImg, setClientImg] = useState(data || {})
    const { setFlashMessage } = useFlashMessage()

    function onFileChange(e) {
        let imgName = Date.now() + String(Math.floor(Math.random() * 1000))

        setPreview(e.target.files[0])

        setClientImg({ ...clientImg, [e.target.name]: e.target.files[0], imgName: imgName, clientId: clientId })
    }

    async function submit() {
        //validations
        if (!clientImg.clientId) {
            setFlashMessage("O cliente é obrigatório", 'error')
            return
        }
        if (!clientImg.image) {
            setFlashMessage("A imagem é obrigatória", 'error')
            return
        }
        if (!clientImg.imgName) {
            setFlashMessage("A imagem é obrigatória", 'error')
            return
        }

        handleSubmit(clientImg)
    }

    return (
        <FormLayout
            title={title}
            actions={
                <>
                    <Button variant="save" onClick={() => submit()}>Salvar</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection label="Imagem">
                <div className="fci-preview-wrap">
                    {preview ? (
                        <div className="fci-preview" style={{ backgroundImage: `url(${URL.createObjectURL(preview)})` }} />
                    ) : clientImg.image ? (
                        <AuthBackgroundImage className="fci-preview" src={`/images/clientImg/${clientImg.image}`} />
                    ) : (
                        <div className="fci-preview fci-preview-empty" />
                    )}
                </div>
                <Input
                    text="Imagem"
                    type="file"
                    name="image"
                    handleOnChange={onFileChange}
                />
            </FormSection>
        </FormLayout>
    )
}

export default FormClientImg
